export const VIEW_NAMES_ENUM = {
    PRE_RECEIVE: "Pre Receive",
    PRE_RECEIVE_WORK_VIEW: "Pre Receive Work View",
    POST_RECEIVE: "Post Receive",
    POST_RECEIVE_WORK_VIEW: "Post Receive Work View",
    DWELL_TIME: "Dwell Time"
};